import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setSelectedVideo as selectVideo,
  setCurrentTab,
  setSubTitleTemplate,
} from "../../store/Subtitle/subTitleSlice";
import { getSubtitles } from "../../thunks/editor/scriptThunks";
import {
  createSubtitle,
  updateVideoSubTitle,
} from "../../thunks/subTitle/subTitle";
import { getFromLocal } from "../../utils/localStorage";
import { Modal } from "../common/modal";
import { Tooltip } from "../common/Tooltip";
import EditTextPopover from "./EditTextPopover";
import LanguagePopover from "./LanguagePopover";
import SubTitleAlignPopover from "./SubTitleAlignPopover";
import SubTitlePopover from "./SubTitlePopover";
import VideoPopover from "./VideoPopover";

const toolsList = [
  {
    name: "Video",
    icon: "/tool/dashboard/static/images/icons/subtitle/video.svg",
    selectedIcon: "/tool/dashboard/static/images/icons/subtitle/selectedVideo.svg",
  },
  {
    name: "Language",
    icon: "/tool/dashboard/static/images/icons/subtitle/language.svg",
    selectedIcon:
      "/tool/dashboard/static/images/icons/subtitle/selectedLanguage.svg",
  },
  {
    name: "Style",
    icon: "/tool/dashboard/static/images/icons/subtitle/styletext.svg",
    selectedIcon:
      "/tool/dashboard/static/images/icons/subtitle/selectedTextStyle.svg",
  },
  {
    name: "Alignment",
    icon: "/tool/dashboard/static/images/icons/subtitle/alignText.svg",
    selectedIcon:
      "/tool/dashboard/static/images/icons/subtitle/selectedTextAlign.svg",
  },
  {
    name: "Edit Text",
    icon: "/tool/dashboard/static/images/icons/subtitle/editText.svg",
    selectedIcon:
      "/tool/dashboard/static/images/icons/subtitle/selectedEditText.svg",
  },
];
const SubtitleTools = ({ isModalVisible, setIsModalVisible }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subtitles } = useSelector((state) => state.script);
  const {
    selectedVideo = {},
    language = "",
    subTitleTemplate = {},
    position = "",
    color = "",
    subTitle,
    currentTab,
    subTitleInfo,
  } = useSelector((state) => state.subTitle);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    dispatch(getSubtitles());
    if (subTitle.length > 0) {
      dispatch(setCurrentTab(4));
    }
  }, []);
  useEffect(() => {
    if (!!subtitles) {
      dispatch(setSubTitleTemplate(subtitles[0]));
    }
  }, [subtitles]);
  const onTabClick = (value) => {
    dispatch(setCurrentTab(value));
    setIsModalVisible(true);
  };

  const callback = () => {
    dispatch(setCurrentTab(4));
    setIsModalVisible(true);
  };
  const updateSubtitleCallback = () => {
    dispatch(setCurrentTab(null));
    setIsModalVisible(false);
  };

  const onNext = () => {
    switch (true) {
      case currentTab === 0 && !!selectedVideo:
        dispatch(selectVideo(selectedVideo));
        dispatch(setCurrentTab(currentTab + 1));
        break;
      case currentTab === 1:
        dispatch(setCurrentTab(currentTab + 1));
        break;
      case currentTab === 2:
        dispatch(setCurrentTab(currentTab + 1));
        break;
      case currentTab === 3:
        if (!!selectedVideo?.id) {
          setIsModalVisible(false);
          dispatch(
            createSubtitle(
              {
                file_id: selectedVideo.id,
                template_id: subTitleTemplate.id,
                color,
                language,
                position,
                user_id: getFromLocal("userId"),
              },
              callback
            )
          );
        } else {
          setIsModalVisible(false);
          setShowModal(true);
        }
        break;
      case currentTab === 4:
        if (subTitle?.length) {
          dispatch(
            updateVideoSubTitle(
              {
                video_id: subTitleInfo?.videoId,
                task_id: subTitleInfo?.taskId,
                file_id: subTitleInfo?.fileId,
                data: subTitle,
                user_id: getFromLocal("userId"),
              },
              updateSubtitleCallback
            )
          );
        }
        break;
      default:
        break;
    }
  };
  const getScreen = (value) => {
    switch (value) {
      case 0:
        return <VideoPopover />;
      case 1:
        return <LanguagePopover />;
      case 2:
        return <SubTitlePopover />;
      case 3:
        return <SubTitleAlignPopover />;
      case 4:
        return <EditTextPopover />;
      default:
        break;
    }
  };

  const getButtonName = () => {
    switch (currentTab) {
      case 0:
        return "Next";
      case 1:
        return "Generate Subtitles";
      case 2:
        return "Save Style";
      case 3:
        return "Save Alignment";
      case 4:
        return "Save Subtitles";
      default:
        break;
    }
  };
  return (
    <>
      {showModal && (
        <Modal
          size="lg"
          center
          onClose={() => {
            setShowModal(false);
          }}
          open={showModal}
        >
          Please Select video
        </Modal>
      )}
      {isModalVisible && (
        <div
          className="fixed inset-0 flex items-center justify-center z-[98] bg-transparent"
          onClick={() => {
            setIsModalVisible(false);
            dispatch(setCurrentTab(null));
          }}
        >
          <div
            className="bg-[#F4F3F6] absolute flex bottom-[80px] shadow-md left-[25%] rounded-lg overflow-hidden w-[711px] z-[9999] h-[467px] "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-full relative">
              {getScreen(currentTab)}
              <div
                className={`absolute bottom-0 right-0 flex justify-end pr-[15px] pb-[15px] pt-[11px] pl-[26px]`}
              >
                <button
                  className="py-[13px] w-[215px] flex justify-center items-center bg-[#11142D] text-white rounded text-sm font-semibold"
                  onClick={onNext}
                >
                  {getButtonName()}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="w-full py-[7px] bg-white flex justify-center items-center absolute bottom-0 z-[100]"
        onClick={(e) => e.stopPropagation()}
      >
        {toolsList.map((tool, index) => {
          const selected = currentTab === index;
          const isDisabled =
            (!!subTitle.length && index < 4) ||
            (!subTitle.length && index === 4);
          return (
            <div
              key={tool.name}
              className={`px-2 py-3 cursor-pointer ${
                selected ? "bg-[#0049C61A] rounded-lg" : ""
              } ${isDisabled ? "!cursor-not-allowed" : ""}`}
              onClick={() => {
                if (isDisabled) {
                  return;
                }
                onTabClick(index);
              }}
            >
              <div
                className={`group relative flex items-center gap-1 ${
                  selected ? "text-[#6043DB] font-bold" : "text-[#11142D]"
                }`}
              >
                <img
                  src={selected ? tool.selectedIcon : tool.icon}
                  alt={tool.name}
                  className="w-5 h-5"
                />
                <span className="text-xs font-bold leading-[14px]">
                  {tool.name}
                </span>
                {!!isDisabled && (
                  <Tooltip className={"w-full min-w-[200px]"}>
                    {!subTitle.length && index === 4
                      ? "Please first generate the subtitles"
                      : "You can not change styles after generate the subtitles"}
                  </Tooltip>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SubtitleTools;
